<div class="footer-disclaimer__content">
  <p class="vc-text-xs" i18n="@@FOOTER.DISCLAIMER.DESCRIPTION">
    Vestiaire Collective has no association and/or affiliation with the brands whose products are offered for sale on
    its website. <br class="desk-only" />
    The authentication of said products is performed independently by Vestiaire Collective.
  </p>
</div>
